import { UserRole } from '../types';

export interface MenuItem {
  label: string;
  icon: string;
  path?: string;
  items?: MenuItem[];
  roles?: UserRole[];
  // Negativan filter: stavka se NEĆE prikazati ovim ulogama, čak i ako bi po
  // `roles` polju bila vidljiva. Korisno kada želimo da iz "vidljivo svima"
  // samo izvadimo jednu ili dve uloge.
  hiddenForRoles?: UserRole[];
  subRoles?: string[];
}

export const menuItems: MenuItem[] = [
  {
    label: 'Dashboard',
    icon: 'pi pi-chart-bar',
    path: '/dashboard',
    hiddenForRoles: ['customer'],
  },
  {
    label: 'Task Management',
    icon: 'pi pi-th-large',
    hiddenForRoles: ['magacin_kontrola', 'customer'],
    items: [
      { label: 'Svi projekti', icon: 'pi pi-th-large', path: '/projects' },
      { label: 'IT Projekti', icon: 'pi pi-folder', path: '/projects/it' },
      { label: 'Grafički Dizajn', icon: 'pi pi-folder', path: '/projects/design' },
      { label: 'Upravljaj folderima', icon: 'pi pi-cog', path: '/project-folders' },
      { label: 'Moji IT tiketi', icon: 'pi pi-wrench', path: '/my-it-tickets' },
    ],
  },
  {
    label: 'Evidencija prisustva',
    icon: 'pi pi-users',
    roles: ['admin', 'attendance_manager', 'direktor'],
    items: [
      { label: 'Radnici', icon: 'pi pi-user', path: '/workers' },
      { label: 'Pozicije', icon: 'pi pi-briefcase', path: '/positions' },
      { label: 'Dnevna evidencija', icon: 'pi pi-calendar-check', path: '/attendance' },
      { label: 'Individualna odsustva', icon: 'pi pi-clock', path: '/absence' },
      { label: 'Državni praznici', icon: 'pi pi-calendar-check', path: '/holidays' },
      { label: 'Mesečni izveštaji', icon: 'pi pi-chart-line', path: '/attendance/reports' },
    ],
  },
  {
    label: 'Delovodnik',
    icon: 'pi pi-file',
    roles: ['admin', 'finansije', 'direktor'],
    items: [
      { label: 'Knjige', icon: 'pi pi-file', path: '/finance/books' },
      { label: 'Tipovi registratora', icon: 'pi pi-file-edit', path: '/finance/book-types' },
      { label: 'Firme', icon: 'pi pi-building', path: '/finance/companies' },
    ],
  },
  {
    label: 'Vreme Proizvodnje',
    icon: 'pi pi-clock',
    roles: ['admin', 'direktor', 'lager'],
    items: [
      { label: 'Zapisi vremena', icon: 'pi pi-list', path: '/production-time' },
      { label: 'Izveštaji', icon: 'pi pi-refresh', path: '/production-time/reports' },
      { label: 'Stanja', icon: 'pi pi-cog', path: '/production-time/states' },
    ],
  },
  {
    label: 'Logistika',
    icon: 'pi pi-shopping-bag',
    roles: ['admin', 'logistika', 'direktor'],
    items: [
      { label: 'Potrošnja', icon: 'pi pi-list', path: '/consumption' },
      { label: 'Materijali', icon: 'pi pi-box', path: '/materials' },
      { label: 'Ulaz u logistiku', icon: 'pi pi-inbox', path: '/logistika/receivings' },
      { label: 'Prijemnice', icon: 'pi pi-file', path: '/receipts' },
      { label: 'Rashodovanje', icon: 'pi pi-trash', path: '/disposals' },
      { label: 'Šarže', icon: 'pi pi-circle', path: '/resins' },
      { label: 'Izveštaji', icon: 'pi pi-file-export', path: '/logistics/reports' },
    ],
  },
  {
    label: 'Nabavka i ponude',
    icon: 'pi pi-shopping-cart',
    roles: ['admin', 'logistika', 'direktor', 'attendance_manager', 'magacin', 'lager', 'finansije', 'finansijski_gotovi', 'odrzavanje'],
    items: [
      { label: 'Kreiraj zahtev', icon: 'pi pi-plus', path: '/procurement/create', roles: ['admin', 'logistika', 'direktor', 'attendance_manager', 'magacin', 'lager', 'finansije', 'finansijski_gotovi', 'odrzavanje'] },
      { label: 'Zahtev za nabavku', icon: 'pi pi-shopping-cart', path: '/procurement', roles: ['admin', 'logistika', 'direktor', 'attendance_manager', 'magacin', 'lager', 'finansije', 'finansijski_gotovi', 'odrzavanje'] },
      { label: 'Tabela zahteva', icon: 'pi pi-table', path: '/procurement/items', roles: ['admin', 'logistika', 'direktor'] },
      { label: 'Roba', icon: 'pi pi-briefcase', path: '/logistics/goods', roles: ['admin', 'logistika', 'direktor'] },
      { label: 'Kategorije robe', icon: 'pi pi-folder', path: '/logistics/categories', roles: ['admin', 'logistika', 'direktor'] },
      { label: 'Statistika', icon: 'pi pi-chart-bar', path: '/procurement/statistics', roles: ['admin', 'logistika', 'direktor'] },
    ],
  },
  {
    label: 'Magacin',
    icon: 'pi pi-building',
    roles: ['admin', 'magacin', 'direktor'],
    items: [
      { label: 'Lista proizvoda', icon: 'pi pi-list', path: '/magacin/products' },
      { label: 'Dodaj proizvod', icon: 'pi pi-plus', path: '/magacin/products/create' },
      { label: 'Ulaz u magacin', icon: 'pi pi-inbox', path: '/magacin/receivings' },
      { label: 'Skini sa stanja', icon: 'pi pi-minus', path: '/magacin/removals' },
      { label: 'Ko duži', icon: 'pi pi-users', path: '/magacin/loans' },
      { label: 'Tipovi proizvoda', icon: 'pi pi-tag', path: '/magacin/product-types' },
      { label: 'Istorija dolazaka', icon: 'pi pi-history', path: '/magacin/arrivals' },
    ],
  },
  {
    label: 'Kontrola Ulaza',
    icon: 'pi pi-inbox',
    roles: ['admin', 'direktor', 'magacin_kontrola'],
    items: [
      { label: 'Nova otpremnica', icon: 'pi pi-plus', path: '/magacin/receivings/create' },
      { label: 'Moje otpremnice', icon: 'pi pi-list', path: '/magacin/receivings' },
    ],
  },
  {
    label: 'Stanje robe',
    icon: 'pi pi-shopping-bag',
    roles: ['admin', 'direktor', 'supplier', 'customer'],
    items: [
      { label: 'Brendovi', icon: 'pi pi-tag', path: '/stanje-robe/brendovi', roles: ['admin', 'direktor', 'supplier'] },
      { label: 'Roba', icon: 'pi pi-box', path: '/stanje-robe/roba', roles: ['admin', 'direktor', 'supplier'] },
      { label: 'Kupci', icon: 'pi pi-users', path: '/stanje-robe/kupci', roles: ['admin', 'direktor', 'supplier'] },
      { label: 'Ulaz na stanje', icon: 'pi pi-arrow-down', path: '/stanje-robe/ulaz', roles: ['admin', 'direktor', 'supplier'] },
      { label: 'Skidanje sa stanja', icon: 'pi pi-arrow-up', path: '/stanje-robe/izlaz', roles: ['admin', 'direktor', 'supplier'] },
      { label: 'Izveštaji', icon: 'pi pi-file-export', path: '/stanje-robe/izvestaji', roles: ['admin', 'direktor', 'supplier'] },
      { label: 'Isporuke', icon: 'pi pi-truck', path: '/stanje-robe/isporuke', roles: ['customer'] },
      { label: 'Trenutno stanje', icon: 'pi pi-chart-bar', path: '/stanje-robe/stanje', roles: ['admin', 'direktor', 'supplier', 'customer'] },
    ],
  },
  {
    label: 'Lager gotovih proizvoda',
    icon: 'pi pi-box',
    roles: ['admin', 'lager', 'direktor'],
    items: [
      { label: 'Trenutno Stanje', icon: 'pi pi-chart-bar', path: '/lager/current-status' },
      { label: 'Proizvodnja', icon: 'pi pi-cog', path: '/lager/production' },
      { label: 'Transport', icon: 'pi pi-truck', path: '/lager/transport' },
      { label: 'Skladište', icon: 'pi pi-th-large', path: '/lager/storage' },
      { label: 'Proizvodi', icon: 'pi pi-tag', path: '/lager/finished-products' },
      { label: 'Firme', icon: 'pi pi-building', path: '/lager/companies' },
      { label: 'Izveštaji', icon: 'pi pi-file-export', path: '/lager/reports' },
    ],
  },
  {
    label: 'Finansijski izvestaj gotovog proizvoda',
    icon: 'pi pi-chart-line',
    roles: ['admin', 'finansijski_gotovi', 'direktor'],
    items: [
      { label: 'Proizvodi', icon: 'pi pi-tag', path: '/financial/finished-products' },
      { label: 'Finansijska lista proizvoda', icon: 'pi pi-list', path: '/financial/production-list' },
    ],
  },
  {
    label: 'Hilti',
    icon: 'pi pi-building',
    roles: ['admin', 'lager', 'direktor'],
    subRoles: ['hilti', 'sef_lagera'],
    items: [
      { label: 'Hilti Proizvodnja', icon: 'pi pi-cog', path: '/hilti/production' },
      { label: 'Hilti Radnice', icon: 'pi pi-users', path: '/hilti/workers' },
      { label: 'Hilti Proizvodi', icon: 'pi pi-tag', path: '/hilti/products' },
      { label: 'Hilti Materijali', icon: 'pi pi-box', path: '/hilti/materials' },
      { label: 'Hilti Magacin Materijala', icon: 'pi pi-chart-bar', path: '/hilti/materials/warehouse' },
      { label: 'Hilti Zaprimanje materijala', icon: 'pi pi-arrow-down', path: '/hilti/materials/receipts' },
      { label: 'Hilti Rashod materijala', icon: 'pi pi-arrow-up', path: '/hilti/materials/disposals' },
      { label: 'Hilti Izveštaji', icon: 'pi pi-file-export', path: '/hilti/reports' },
    ],
  },
  {
    label: 'IT Upravljanje',
    icon: 'pi pi-desktop',
    roles: ['admin', 'direktor'],
    items: [
      { label: 'Oprema', icon: 'pi pi-desktop', path: '/it/equipment' },
      { label: 'Naziv opreme', icon: 'pi pi-tag', path: '/it/equipment-categories' },
      { label: 'Mreža', icon: 'pi pi-sitemap', path: '/it/network' },
      { label: 'Serveri', icon: 'pi pi-server', path: '/it/servers' },
      { label: 'Računari', icon: 'pi pi-desktop', path: '/it/computers' },
      { label: 'Korisnici', icon: 'pi pi-users', path: '/it/users' },
      { label: 'Pregled mreže', icon: 'pi pi-eye', path: '/it/network-overview' },
      { label: 'Subnetovi', icon: 'pi pi-share-alt', path: '/it/subnets' },
      { label: 'IP adrese', icon: 'pi pi-list', path: '/it/ip-assignment' },
      { label: 'Uređaji', icon: 'pi pi-th-large', path: '/it/devices' },
      { label: 'Subnet kalkulator', icon: 'pi pi-calculator', path: '/it/subnet-calculator' },
      { label: 'VLAN upravljanje', icon: 'pi pi-sliders-h', path: '/it/vlan-management' },
      { label: 'Port konfiguracija', icon: 'pi pi-wrench', path: '/it/port-config' },
      { label: 'IP Pregled', icon: 'pi pi-search', path: '/it/ip-overview' },
      { label: 'IT Incidenti', icon: 'pi pi-exclamation-circle', path: '/it/incidents' },
      { label: 'IT Tiketi', icon: 'pi pi-wrench', path: '/my-it-tickets' },
    ],
  },
  {
    label: 'Administracija',
    icon: 'pi pi-cog',
    roles: ['admin'],
    items: [
      { label: 'Activity Logs', icon: 'pi pi-refresh', path: '/admin/activity-logs' },
      { label: 'Korisnici', icon: 'pi pi-users', path: '/users' },
      { label: 'Podešavanja Notifikacija', icon: 'pi pi-bell', path: '/admin/notifications' },
    ],
  },
];

export const getMenuItemsForUser = (userRole: UserRole, subRole?: string): MenuItem[] => {
  return menuItems.filter(item => {
    // Negativan filter ima prioritet — ako je ova uloga eksplicitno isključena,
    // sakrij stavku bez obzira na ostale provere.
    if (item.hiddenForRoles && item.hiddenForRoles.includes(userRole)) return false;

    // If no roles specified, item is available to all
    if (!item.roles) return true;
    
    // Check if user role is in allowed roles
    if (!item.roles.includes(userRole)) return false;
    
    // If subRoles specified, check subRole
    if (item.subRoles) {
      // Admin uvek vidi sve stavke bez obzira na subRole
      if (userRole === 'admin') {
        return true;
      }

      // Ostali moraju imati odgovarajući subRole
      if (subRole) {
        return item.subRoles.includes(subRole);
      }

      // Ako postoji subRole restrikcija, a korisnik nema subRole, sakrij stavku
      return false;
    }
    
    return true;
  }).map(item => {
    // Filter sub-items by role as well
    if (item.items) {
      const filteredItems = item.items.filter(subItem => {
        if (subItem.hiddenForRoles && subItem.hiddenForRoles.includes(userRole)) return false;
        if (!subItem.roles) return true;
        return subItem.roles.includes(userRole);
      });
      return { ...item, items: filteredItems };
    }
    return item;
  });
};



